import { MinusCircleOutlined } from '@ant-design/icons';
import { AutoComplete, Button, Col, Form, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField } from '../../../../../contextRedux/Contract/ContractModel';
import { addAgents, removeAgents, updateAgents } from '../../../../../contextRedux/WorkPlace/WorkPlaceModel';
import { RootState } from '../../../../../store';

const AgentTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const workPlaceId = useSelector((state: RootState) => state?.models?.workPlace?.id) ?? '';
  const agents = useSelector((state: RootState) => state?.store?.user?.data || []);
  const initialValues = useSelector((state: RootState) => state?.models?.workPlace?.agents || []);

  const filteredAgents = agents.filter(
    (agent: any) => !initialValues.some((existingAgent: any) => existingAgent?.userId === agent?.id)
  );

  useEffect(() => {
    form.setFieldsValue({ agents: Array.isArray(initialValues) ? initialValues : [] });
  }, [initialValues, form]);

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().includes(inputValue.toLowerCase());
  };

  const handleSelectAgent = (value: any, index: number): void => {
    const agent = filteredAgents.find((a: any) => a?.name === value);
    if (agent) {
      const newWorkPlaceAgent = {
        id: '',
        userId: agent?.id,
        workPlaceId,
        name: agent?.name,
        user: {
          id: agent?.id,
          name: agent?.name,
        },
      };

      const updatedAgents = form.getFieldValue('agents') || [];
      updatedAgents[index] = newWorkPlaceAgent;
      form.setFieldsValue({ agents: updatedAgents });

      dispatch(updateAgents({ index, updates: newWorkPlaceAgent }));
    }
  };

  const handleAddAgent = (addFn: any) => {
    const newWorkPlaceAgent = {
      id: '',
      userId: '',
      workPlaceId,
      name: '',
      user: {
        id: '',
        name: '',
      },
    };

    addFn(newWorkPlaceAgent);
    dispatch(addAgents(newWorkPlaceAgent));
  };

  const handleRemoveAgent = (index: number, removeFn: any) => {
    removeFn(index);
    dispatch(removeAgents(index));
  };

  return (
    <Form
      form={form}
      name='agentForm'
      initialValues={{ agents: initialValues }}
      onValuesChange={handleFieldChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
    >
      <Form.List name='agents'>
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <Row key={field.key} gutter={16} align='middle' style={{ marginBottom: '20px' }}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...field}
                    label='Selectează Agent'
                    name={[field.name, 'user', 'name']}
                    rules={[{ required: true, message: 'Selectează un agent!' }]}
                  >
                    <AutoComplete
                      options={filteredAgents.map((agent: any) => ({ value: agent?.name || '' }))}
                      onSelect={(value: any) => handleSelectAgent(value, index)}
                      filterOption={handleFilter}
                      placeholder='Alege un agent'
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Button
                    type='link'
                    icon={<MinusCircleOutlined />}
                    onClick={() => handleRemoveAgent(field.name, remove)}
                  />
                </Col>
              </Row>
            ))}
            <Form.Item>
              <Button type='dashed' onClick={() => handleAddAgent(add)} style={{ width: '100%' }}>
                Adaugă un Agent
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </Form>
  );
};

export default AgentTab;
